import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { QRCode } from "react-qrcode-logo";

import useTheme from "hooks/useTheme";
import useNotification from "hooks/useNotification";

import CopyIcon from "theme/icons/Copy";
import CloseIcon from "theme/icons/Close";

const AccountCardQRModal = ({ isOpen, setIsOpen, modalInfo, action }) => {
	const { appLanguage, themeColor } = useTheme();
	const { notify } = useNotification();

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full items-center">
									<div className="flex flex-col w-full items-center justify-center space-y-7">
										<div className="flex w-full items-center justify-between">
											<p className={`text-md ${themeColor?.text}`}></p>
											<CloseIcon
												className="w-4 cursor-pointer"
												fill={themeColor?.hex}
												onClick={() => setIsOpen(false)}
											/>
										</div>

										<div className="flex flex-col w-full items-center justify-center space-y-0">
											<p className={`text-sm ${themeColor?.text}`}>{appLanguage?.accountName}</p>
											<p className={`text-md font-bold ${themeColor?.text}`}>{modalInfo?.name}</p>
										</div>
										<div className="flex flex-col w-full items-center justify-center space-y-0">
											<p className={`text-sm ${themeColor?.text}`}>{appLanguage?.blockchain}</p>
											<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.algorand}</p>
										</div>
										<div className="flex flex-col w-full items-center justify-center space-y-0">
											<p className={`text-sm ${themeColor?.text}`}>{appLanguage?.accountAddress}</p>
											<p className={`text-md font-bold ${themeColor?.text}`}>
												{modalInfo?.["account-address"].slice(0, 5) +
													"..." +
													modalInfo?.["account-address"].slice(-5)}
											</p>
											<CopyIcon
												className={`w-4 cursor-pointer`}
												fill={themeColor?.hex}
												onClick={() => {
													navigator.clipboard.writeText(`algorand://${modalInfo?.["account-address"]}`);
													notify("success", "Copied to clipboard");
												}}
											/>
										</div>

										<QRCode
											value={`algorand://${modalInfo?.["account-address"]}`}
											enableCORS={true}
											eyeRadius={5}
											fgColor={themeColor?.hex}
										/>
									</div>
								</div>

								{/* <div className="w-full flex mt-4 space-x-3 justify-center">
									{sendingTransaction ? (
										<img className="animate-spin mx-auto h-5 w-auto" src="/media/logo.png" alt="img" />
									) : (
										<button
											type="button"
											className={`text-sm text-white ${themeColor?.bg} px-3 py-2 rounded-lg hover:shadow-lg`}
											onClick={() => action()}
										>
											Share QR Code
										</button>
									)}
								</div> */}
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default AccountCardQRModal;
